module.exports = __webpack_public_path__ + "static/media/feelinkgood.9ca653a7.png";